export default __webpack_public_path__ + "static/media/Number_1_selected_hsb.cb303db1.svg";